<template>
    <div class="fps-graphing m-b">
        <div class="fps-graphing-item" v-for="game in games" :key="'game-' + game.id">
            <img :src="game.image_url" class="img-responsive">
            <div class="fps-graphing-item-fps">
                <div class="fps-text">
                    {{ game.fps }}
                </div>
                <div class="vsync" v-if="game.vsync == 1">V-SYNC</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "GamesInfoOverlay",
    props: {
        games: {
            type: Object | Array,
            required: true
        }
    }
}
</script>
